import { render } from "./BadgesManagementView.vue?vue&type=template&id=6f3b27b7"
import script from "./BadgesManagementView.vue?vue&type=script&lang=js"
export * from "./BadgesManagementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__